import {Form} from 'semantic-ui-react';

function FormSelect(props) {
  const {
    input,
    required, label, placeholder, options,
    multiple, size,
    meta: {touched, error}
  } = props;
  const id = props.id || input.name;
  const value = (multiple && !input.value) ? [] : input.value;
  const exactLabel = ['.', '?', '!', '؟'].includes(label.charAt(label.length - 1));

  return (
    <Form.Field
      {...input}
      fluid
      search
      multiple={multiple}
      id={id}
      label={exactLabel ? label : `${label} :`}
      required={required}
      options={options}
      value={value}
      onFocus={handleEvent.bind(null, input.onFocus)}
      onChange={handleEvent.bind(null, input.onChange)}
      onBlur={handleEvent.bind(null, input.onBlur)}
      control={Form.Select}
      placeholder={placeholder}
      size={size}
      error={(touched && error != null) ? error : false}
      noResultsMessage='موردی یافت نشد!'
    />
  );
}

function handleEvent(eventHandler, param, data) {
  const value = param.type === 'blur' ? param.value : data.value;
  return eventHandler(value);
}

FormSelect.defaultProps = {
  exactLabel: false,
  multiple: false,
  placeholder: 'انتخاب کنید...',
  options: []
};

export default FormSelect;
